import React from 'react'

const RightArrowIcon = () => {
    return (
        <div>
            <svg width="183" height="22" viewBox="0 0 183 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 9C0.89543 9 0 9.89543 0 11C0 12.1046 0.89543 13 2 13V9ZM162.69 19.8803C162.69 20.9849 164.043 21.766 164.999 21.2137L180.381 12.3333C181.337 11.781 181.337 10.219 180.381 9.66667L164.999 0.786328C164.043 0.234043 162.69 1.01509 162.69 2.11966V19.8803ZM2 13H164.69V9H2V13Z" fill="#B1B1B1" />
            </svg>

        </div>
    )
}

export default RightArrowIcon
